import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { tap } from 'rxjs/internal/operators/tap';
import { FormControl } from '@angular/forms';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-centers-center-schedules-card',
  templateUrl: './centers-center-schedules-card.component.html',
  styleUrls: ['./centers-center-schedules-card.component.scss']
})
export class CentersCenterSchedulesCardComponent implements OnInit, OnDestroy {

  @Input() center;
  @Input() schedules;
  @Input() existingSchedules;
  existingSchedule = new FormControl(null);
  deleteScheduleSubscription: Subscription;

  constructor(private centersCentersService: CentersCentersService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public addSchedule() {
    if (this.existingSchedule.value === null) {
      this.router.navigate(['schedule'], { relativeTo: this.activatedRoute });
    } else {
      this.centersCentersService.linkExistingCenterSchedule(this.existingSchedule.value.InternalId, this.center.InternalId).pipe(
        tap(o => this.centersCentersService.refreshCenter()),
        tap(o => this.existingSchedule.patchValue(null))
      ).subscribe();
    }
  }

  public editSchedule(schedule) {
    this.router.navigate(['schedule', schedule.InternalId], { relativeTo: this.activatedRoute });
  }

  public deleteSchedule(schedule) {
    this.deleteScheduleSubscription = this.centersCentersService.deleteCenterSchedule(schedule.InternalId, this.center.InternalId).pipe(
      tap(o => this.snackbarService.open('stores-page.snackbar messages.update center success', 'success')),
      tap(o => this.centersCentersService.refreshCenter()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.deleteScheduleSubscription) { this.deleteScheduleSubscription.unsubscribe(); }
  }
}
